// extracted by mini-css-extract-plugin
export var compactFilters = "_fl-4";
export var detailImage = "_fl-1";
export var dropdownContainer = "_fl-2";
export var imageContainer = "_fl-0";
export var selectedCard = "_fl-3";